import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appNoWhitespace]'
})
export class NoWhitespaceDirective {

  constructor(private el: ElementRef, private control: NgControl) { }

  // Listen for input events and trim spaces on change
  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = this.el.nativeElement.value;
    const trimmedValue = input.trim();

    if (input !== trimmedValue) {
      this.control.control?.setValue(trimmedValue);  // Update the form control value
    }
  }

  // Listen for blur event to trim spaces when leaving the input
  @HostListener('blur')
  onBlur(): void {
    const input = this.el.nativeElement.value;
    const trimmedValue = input.trim();
    this.control.control?.setValue(trimmedValue);  // Update the form control value
  }
}
